import React from "react";
import { observer } from "mobx-react";
import { errorExplanationOptions, triggerAnalystCommentModal, getCommentIconRenderingInfo, getInputRenderingInfo, dateFormatter, getUiNumInputErrorState, setUiNumInputErrorState} from '../helpers'
import store from './Stores/SurveyStore'
import { saveValueNew, openPrevYearPanel } from '../control'
import {
    Tooltip,
} from 'react-tippy';
import { ElementType, TextFormat } from "../Enums/constants";
import { getSurveyResponseValue, setSurveyResponseValue } from "../Helpers/General/SurveyResponsesHelper";

var focusValue;
const SurveyTextInput = observer((props) => {
    const onChange = e => {
        setSurveyResponseValue(props.name, e.target.value, props);
    };
    const getValue = () => {
        if (store.questionMode) {
            return props.name;
        } else if (props.dataRow) {
            return (props.dataRow[props.name]);
        }
        if (props.inputType === ElementType.DATE) {
            return dateFormatter(getSurveyResponseValue(props.name, props.rowData).substring(0, 10));
        }
        return (getSurveyResponseValue(props.name, props.rowData));
    }

    const onFocus = e => {
        openPrevYearPanel(props.name);
        focusValue = e.target.value;
        e.target.setSelectionRange(e.target.value.length, e.target.value.length);
    }

    const renderTextInput = () => {
        return (
            <input onChange={onChange} autoComplete="off" onBlur={onBlur} onFocus={onFocus} className={props.inputType === ElementType.DATE ? "numInput" : "textInput " + inputRenderingInfo.textClassName + inputRenderingInfo.inputColor + " " + additionalStyling + " " + getUiNumInputErrorState(props.name) + isNarrowInputRender()} disabled={inputRenderingInfo.isDisabled} placeholder={props.placeholder} type="text" name={props.name} value={getValue()}></input>
        );
    }
    const isNarrowInputRender = () => {
        if (props.isNarrowInput) return " narrowInputBox"
        else return ""
    }
    const renderTooltipText = () => {
        //<div className="genericTooltip">
        //    <span dangerouslySetInnerHTML={{ __html: inputRenderingInfo.feedbackComment }}></span>
        //    <br />
        //    {errorExplanationOptions(props.name, inputRenderingInfo, getValue())}

        //</div>
        if (getUiNumInputErrorState(props.name) === "invalidInput") {
            return (<div className="genericTooltip">
                <span>Invalid Format. Please use the format shown in the placeholder.</span>
            </div>)
        }
        return (
            <div className="genericTooltip">
                <span dangerouslySetInnerHTML={{ __html: inputRenderingInfo.feedbackComment }}></span>
                <br />
                {errorExplanationOptions(props.name, inputRenderingInfo, getValue())}
            </div>
        );
    }
    const validate = (value) => {
        var objRegExp = /^\d{1,2}(\-|\/|\.)\d{1,2}$/

        //check to see if in correct format
        if (props.format == TextFormat.DD_MM) {
            if (!objRegExp.test(value))
                return false
            else return true

        }
        return true
        
    }

    const onBlur = e => {
        var v = getValue();
        let isValid = validate(v);

        setUiNumInputErrorState(props.name, isValid)

        //save should go thru the array first saveResponseValue in helpers not the direct target value... 
        if (isValid && v != focusValue) {
            saveValueNew(props.name, e.target.value, {}); //only save if  not in question mode
        }
        store.previousYearValue = ""
        


    };
    var additionalStyling = props.inputStyleName 
    if (!additionalStyling) additionalStyling = ""

    var commentRenderingInfo = getCommentIconRenderingInfo(props.name)
    var inputRenderingInfo = getInputRenderingInfo(props.name, props.inputType)
    //console.log(inputRenderingInfo, props.name)
    return (
        <React.Fragment >
            {(inputRenderingInfo && inputRenderingInfo.feedbackComment || getUiNumInputErrorState(props.name) == "invalidInput")  &&
                <Tooltip
                    disabled={ store.questionMode}
                    position="top"
                    trigger="mouseenter"
                    arrow="true"
                    delay={250}
                    size="small"
                    interactive="true"
                    hideOnClick="false"
                    animation="fade"
                    html={renderTooltipText()}
                popperOptions={{
                    modifiers: {
                        preventOverflow: {
                            enabled: false,
                        },
                        flip: {
                            enabled: false,
                        },
                    },
                }}
                >
                {renderTextInput()}
                </Tooltip>
            }

            {(inputRenderingInfo == undefined || !inputRenderingInfo.feedbackComment && getUiNumInputErrorState(props.name) != "invalidInput") &&
                renderTextInput()
            }
            
            &nbsp;

                <a title={commentRenderingInfo.hoverComment}><i className={"fa fa-comment" + commentRenderingInfo.className} onClick={() => triggerAnalystCommentModal(props.name)} style={{ visibility: store.analystMode || (store.accountInfo && store.accountInfo.isAnalyst && commentRenderingInfo.className) ? "" : "hidden" }} ></i></a>
        </React.Fragment>
    );
});
export default SurveyTextInput;


//the styles on the comment icon are to show analysts when they have commented on something, show that icon even outside of admin mode